/**
 * CategoryBreakdownCard - Visual breakdown by category
 *
 * Shows how reflections are distributed across categories
 * with visual bar charts.
 */

import React from 'react';

function CategoryBreakdownCard({ breakdown, categories, onCategoryClick }) {
  if (!breakdown || breakdown.length === 0) {
    return (
      <div className="bento-card bento-card--small">
        <div className="bento-card-header">
          <h2 className="bento-card-title">
            <span className="bento-card-icon">📁</span>
            Categories
          </h2>
        </div>
        <div className="on-this-day-empty">
          <p>No category data yet.</p>
        </div>
      </div>
    );
  }

  // Find max count for scaling bars
  const maxCount = Math.max(...breakdown.map(b => b.count), 1);

  // Get category info (icon, icon_url, name) from categories list
  const getCategoryInfo = (slug) => {
    const cat = categories?.find(c => c.slug === slug);
    return {
      icon: cat?.icon || '📁',
      iconUrl: cat?.icon_url || null,
      name: cat?.name || slug
    };
  };

  return (
    <div className="bento-card bento-card--small">
      <div className="bento-card-header">
        <h2 className="bento-card-title">
          <span className="bento-card-icon">📁</span>
          Categories
        </h2>
      </div>
      <div className="category-breakdown-list">
        {breakdown.slice(0, 5).map(item => {
          const catInfo = getCategoryInfo(item.category_slug);
          const barWidth = (item.count / maxCount) * 100;

          return (
            <div
              key={item.category_slug}
              className="category-item category-item--clickable"
              onClick={() => onCategoryClick && onCategoryClick(item.category_slug)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onCategoryClick && onCategoryClick(item.category_slug);
                }
              }}
            >
              <span className="category-icon">
                {catInfo.iconUrl ? (
                  <img src={catInfo.iconUrl} alt="" style={{ width: '2rem', height: '2rem', objectFit: 'contain', verticalAlign: 'middle' }} />
                ) : catInfo.icon}
              </span>
              <span className="category-name">{catInfo.name}</span>
              <div className="category-bar-container">
                <div
                  className="category-bar"
                  style={{ width: `${barWidth}%` }}
                />
              </div>
              <span className="category-count">{item.count}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CategoryBreakdownCard;
